/*
 * File: /src/stores/shop-products-edit.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Friday, 20th July 2018 2:20:53 pm
 * Last Modified: Tuesday, 14th August 2018 3:52:09 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
import { StoreDefaultMetafieldsHelper } from '@/helpers'

const initialState = () => ({
    scope: 'pages'
})

const state = StoreDefaultMetafieldsHelper.buildState({ 
    state: initialState()
})


const actions = StoreDefaultMetafieldsHelper.buildActions({
    actions: {}
})

const mutations = StoreDefaultMetafieldsHelper.buildMutations({
    mutations: {}
})

const getters = StoreDefaultMetafieldsHelper.buildGetters({
    getters: {}
})

export default {
    namespaced: true,
    state, actions, mutations, getters
}


// WEBPACK FOOTER //
// ./src/stores/shop-pages-edit.js